/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function WarningCircleFill({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 13.071a1.055 1.055 0 1 1 0-2.11 1.055 1.055 0 0 1 0 2.11m-.88-9.567c0-.318.22-.575.49-.575h.78c.27 0 .49.257.49.575v2.633c0 .543.056 1.231-.051 1.759l-.243 1.189c-.12.799-1.053.796-1.172 0l-.243-1.19c-.107-.527-.05-1.215-.05-1.758z" clipRule="evenodd" /></svg>;
}
;